import { render, staticRenderFns } from "./editLeave.vue?vue&type=template&id=16094d1a&"
import script from "./editLeave.vue?vue&type=script&lang=js&"
export * from "./editLeave.vue?vue&type=script&lang=js&"
import style0 from "./editLeave.vue?vue&type=style&index=0&id=16094d1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports